"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Type;
(function (Type) {
    Type["Autocomplete"] = "autocomplete";
    Type["Search"] = "search";
    Type["SmartCollection"] = "smart-collection";
    Type["Recommendations"] = "recommendations";
    Type["Feedback"] = "feedback";
    Type["Content"] = "content";
})(Type = exports.Type || (exports.Type = {}));
//# sourceMappingURL=Type.js.map